
import { memo } from 'react';
import { Carousel } from 'react-responsive-carousel'
import './style.css';
interface IProp{
    currentAssetImages:Array<any>
}
const ImageViewer=({currentAssetImages}:IProp)=>{
  return (
    <div className='imagesContent'>
        {currentAssetImages.length > 0 ? (
            <div className='imageAssetContent'>
              <Carousel showThumbs={false} width={'100%'}>
                {currentAssetImages.map((each: any, index: number) => (
                  <img
                    key={index}
                    style={{ width: '100%', height: '198px' }}
                    src={each.url}
                  />
                ))}
              </Carousel>
            </div>
          ) : (
            <div className='textContent'>
              <h3
                style={{
                  wordWrap: 'break-word',
                  width: '230px',
                  whiteSpace: 'pre-line',
                }}
              >
                No selected any asset yet to preview
              </h3>
            </div>
          )}
    </div>
  )
}
export default memo(ImageViewer);
